import { Link } from 'react-router-dom'
import { useMemo, type ReactNode } from 'react'
import { useGlobalSchema } from '../hooks/useSchemaOrg'
import { schemaGraph, schemaOrganization, schemaWebSite } from '../lib/schema-org'

/** Minimal chrome for embedded checkout — no site header/footer. */
export function TicketsShell({
  backTo,
  backLabel = '← Zurück',
  children,
}: {
  backTo: string
  backLabel?: string
  children: ReactNode
}) {
  const globalSchema = useMemo(() => schemaGraph(schemaOrganization(), schemaWebSite()), [])
  useGlobalSchema(globalSchema)

  return (
    <div className="tickets-shell">
      <div className="tickets-shell__bar">
        <Link to={backTo} className="tickets-shell__back">
          {backLabel}
        </Link>
      </div>
      <div className="tickets-shell__main">{children}</div>
    </div>
  )
}
